import React from 'react';
import PropTypes from 'prop-types';
import ShortId from 'shortid';
import ObjectPath from 'object-path';
import InputLabel from '../InputLabel';
import Styles from './Checkbox.module.scss';

const Checkbox = ({
  field,
  children,
  onChange = () => {},
  onClick = () => {},
  value,
  name,
  checked
}) => {
  const htmlFor = ShortId.generate();

  const attrs = {};
  attrs.checked = ObjectPath.get(field, 'value') ? true : checked;

  return (
    <div className={Styles['checkbox']}>
      <input
        value={value}
        name={name}
        type="checkbox"
        onChange={onChange}
        onClick={onClick}
        id={htmlFor}
        {...attrs}
        {...field}
      />
      <InputLabel htmlFor={htmlFor}>{children}</InputLabel>
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.any,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ]),
  field: PropTypes.object,
  form: PropTypes.object
};

export default Checkbox;
